/**
 * 008-reporting-dashboards T009 / 003-customers-tiers-credit T035 — GAP-7 landed
 * (`GET /admin/customers/credit-breaches`, `2026-09-14`): wired for real, replacing the previous
 * hard-coded "Not available" placeholder (see git history for that gap's own note on why no field
 * or route existed before this).
 *
 * `count` is the API's own count of customers whose outstanding exceeds their credit limit
 * (`CustomerBalance.OverLimit`) — nothing is paged, summed or compared client-side (constitution I,
 * FR-017's "never fetch the whole set to count it"). Drills through to `/customers`, the same list
 * whose `overLimit` field badges the rows this count describes (003 T035, `columns.tsx`) — tile and
 * list read the same flag, so they can never disagree, matching `StockExceptionsTile`'s pattern.
 * Drawn by `StatusCard`.
 */
import { PiWarningDuotone as AlertTriangle } from "react-icons/pi";
import { TileBoundary } from "./TileBoundary";
import { StatusCard, UnreadableStatusCard } from "./StatusCard";

const icon = <AlertTriangle aria-hidden className="size-5" />;

function unreadable(error: unknown) {
  return <UnreadableStatusCard title="Credit-limit breaches" icon={icon} error={error} fallback="Could not be read — this is not the same as zero breaches." />;
}

export function CreditBreachTile({ resolve }: { resolve: Promise<number> }) {
  return (
    <TileBoundary resolve={resolve} errorFallback={unreadable}>
      {(count) => (
        <StatusCard
          title="Credit-limit breaches"
          icon={icon}
          tone={count > 0 ? "destructive" : "success"}
          value={count}
          caption="Customers whose outstanding balance exceeds their credit limit."
          link={{ to: "/customers", label: "Open the customer list" }}
        />
      )}
    </TileBoundary>
  );
}
